import { useMemo, useRef } from 'react';
import { buildClientURL } from '@/utilities/helpers/buildClientURL';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';
import '@/game-client/styles/index.scss';
import { handleLoad } from './helpers/handleLoad';

import { useStore } from '@/store/useStore';

const GameClient = () => {
  const orientation = useAppOrientation();
  const isGameWindowOpen = useStore((s) => s.gameWindowContext.gameWindowOpen);

  const GAME_CLIENT_URL = useMemo(() => buildClientURL(), []);

  const iframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <iframe
      ref={iframeRef}
      id="casino-game-client"
      src={GAME_CLIENT_URL}
      title="Casino Game"
      allow="geolocation; local-network-access"
      frame-orientation={orientation}
      className={`game-client_iframe ${isGameWindowOpen ? 'blur' : ''}`}
      loading="eager"
      onLoad={() => handleLoad(iframeRef)}
    />
  );
};

export default GameClient;
